import { GA4Event} from "./GA4Event";

export function buildBookDeclinedByUser(message) {
	const { attributes } = message;
	const { eventData } = new GA4Event("book_declined_by_user", {
		search_input: attributes.search_input || '',
		item_id: attributes.item_id || '',
		item_name: attributes.item_name || '',
		item_category: attributes.item_category || '',
		rebuy_price: attributes.rebuy_price || '',
		currency: attributes.currency || '',
		component: attributes.component || '',
		versandbox_id: attributes.versandbox_id || '',
	});
	return eventData;
}
